import { render } from "./HLJMedal.vue?vue&type=template&id=a1f5d7dc&scoped=true"
import script from "./HLJMedal.vue?vue&type=script&lang=js"
export * from "./HLJMedal.vue?vue&type=script&lang=js"

import "./HLJMedal.vue?vue&type=style&index=0&id=a1f5d7dc&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f5d7dc"]])

export default __exports__